export default function FooterSection() {
  return (
    <footer id="footer" className="relative w-full bg-background-100 border-t border-background-200/40">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h4 className="text-base font-bold font-heading text-primary-400 mb-4">
              6080新视觉影院
            </h4>
            <p className="text-xs md:text-sm text-foreground-500 leading-relaxed mb-4">
              6080新视觉影院是国内领先的高清电影电视剧免费在线观看平台，提供不缓冲极速秒开播放体验，全集不卡顿流畅播放，是您的免费影视大全。
            </p>
            <div className="flex items-center gap-3">
              <a href="#hero" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200/60 text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#hero" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200/60 text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#hero" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200/60 text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">
                <i className="ri-bilibili-line text-sm"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold font-heading text-foreground-700 mb-4">
              快速导航
            </h4>
            <ul className="space-y-2.5">
              <li><a href="#index" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">影视索引</a></li>
              <li><a href="#cards" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">热播推荐</a></li>
              <li><a href="#ranking" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">热播榜单</a></li>
              <li><a href="#carousel" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">焦点专题</a></li>
              <li><a href="#media" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">精彩预告</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold font-heading text-foreground-700 mb-4">
              热门分类
            </h4>
            <ul className="space-y-2.5">
              <li><span className="text-xs text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">动作电影</span></li>
              <li><span className="text-xs text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">国产电视剧</span></li>
              <li><span className="text-xs text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">韩剧热播</span></li>
              <li><span className="text-xs text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">悬疑惊悚</span></li>
              <li><span className="text-xs text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">科幻大片</span></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold font-heading text-foreground-700 mb-4">
              合作伙伴
            </h4>
            <p className="text-xs text-foreground-500 leading-relaxed">
              暂无合作信息展示，期待与优质影视内容方携手合作。
            </p>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/40 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-400">
            6080新视觉影院 &copy; 2026 · 高清电影电视剧免费在线观看 · 不缓冲极速秒开
          </p>
          <p className="text-xs text-foreground-400">
            本站所有资源均来自互联网，仅供学习交流使用
          </p>
        </div>
      </div>
    </footer>
  );
}